// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Dl88","title":"AfterBackImages_title__3Epyt","images":"AfterBackImages_images__2y0U3"};